import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=d99c9b9c&scoped=true"
import script from "./dynamic.vue?vue&type=script&lang=js"
export * from "./dynamic.vue?vue&type=script&lang=js"
import style0 from "./dynamic.vue?vue&type=style&index=0&id=d99c9b9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99c9b9c",
  null
  
)

export default component.exports